import { IsInformationCorrect } from '@interfaces/mfe/mfe-personal-info-client.interface';
import { Action, createReducer, on } from '@ngrx/store';

import {
  ResetMfePersonalInfoClientData,
  UpdateMfePersonalInfoClientData,
  UpdateMfePersonalInfoClientMfeFields,
} from '../../actions/mfe-personal-info-client/mfe-personal-info-client.actions';
import { formatCitizenshipData } from '../personal-data/personal-data.reducer';

export interface MfePersonalInfoClientState {
  isLoaded: boolean;
  isInformationCorrect: IsInformationCorrect | null;
  personalInfo: {
    affiliationStartDate?: string;
    firstName: string;
    middleName: string;
    lastName: string;
    email: string;
    birthDate: string;
    citizenshipStatus: string;
    gender: string;
    countryOfCitizenship: string;
    suffix: string;
    ssn?: string;
  };
}

export const initialState: MfePersonalInfoClientState = {
  isLoaded: false,
  isInformationCorrect: null,
  personalInfo: {
    affiliationStartDate: '',
    firstName: '',
    middleName: '',
    lastName: '',
    email: '',
    birthDate: '',
    citizenshipStatus: '',
    gender: '',
    countryOfCitizenship: '',
    suffix: '',
    ssn: '',
  },
};

const mfePersonalInfoClientReducer = createReducer(
  initialState,
  on(UpdateMfePersonalInfoClientData, (state, { payload }) => ({
    ...state,
    isLoaded: true,
    isInformationCorrect: payload.isInformationCorrect,
    personalInfo: { ...state.personalInfo, ...payload.personalInfo },
  })),
  on(UpdateMfePersonalInfoClientMfeFields, (state, { payload }) => {
    const updates: Partial<MfePersonalInfoClientState['personalInfo']> = {};
    if (payload.gender !== undefined) {
      updates.gender = payload.gender;
    }
    if (payload.affiliationStartDate !== undefined) {
      updates.affiliationStartDate = payload.affiliationStartDate;
    }
    if (payload.suffix !== undefined) {
      updates.suffix = payload.suffix;
    }
    if (payload.countryOfCitizenship !== undefined) {
      updates.countryOfCitizenship = payload.countryOfCitizenship;
    }
    if (payload.citizenshipStatus !== undefined) {
      updates.citizenshipStatus = formatCitizenshipData(payload.citizenshipStatus);
    }
    return {
      ...state,
      personalInfo: { ...state.personalInfo, ...updates },
    };
  }),
  on(ResetMfePersonalInfoClientData, () => initialState),
);

export function reducer(state: MfePersonalInfoClientState | undefined, action: Action) {
  return mfePersonalInfoClientReducer(state, action);
}
